import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ModalIDs } from "src/shared/config";

import { initialState } from "../config/constants";

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{ id: ModalIDs; data?: Object }>,
    ) => {
      // @ts-ignore
      state[action.payload.id].open = true;
      // @ts-ignore
      state[action.payload.id].data = action.payload.data;
    },
    closeModal: (state, action: PayloadAction<ModalIDs>) => {
      // @ts-ignore
      state[action.payload].open = false;
    },
  },
});

export const { actions } = modalSlice;

export default modalSlice.reducer;
